export function wizardPhase(stepIndex) {
  if (stepIndex <= 0) return 0
  if (stepIndex <= 1) return 1
  if (stepIndex <= 3) return 2
  return 3
}

export function showWizardStep(steps, activeIndex) {
  steps.forEach((step, index) => {
    const active = index === activeIndex
    step.classList.toggle("hidden", !active)
    step.style.opacity = active ? "0" : "0"

    if (!active) return

    step.style.transform = "translateY(20px)"
    requestAnimationFrame(() => {
      step.style.transition = "opacity 0.4s ease, transform 0.4s ease"
      step.style.opacity = "1"
      step.style.transform = "translateY(0)"
    })
  })
}

export function syncProgressSemantics(tabs, phase) {
  tabs.forEach((element, index) => {
    const active = index === phase
    element.classList.toggle("wizard-tab--active", active)
    element.setAttribute("aria-current", active ? "step" : "false")
  })
}
